import doctorIcon from "../assets/icons/doctor.svg"
import waveIcon from "../assets/icons/wave.svg"
import headspaceIcon from "../assets/icons/headspace.svg"

export const data = {
  heading: "Your subscription includes:",
  modalHeading:
    "Complimentary <span class='inline sm:hidden'><br /></span>subscriber benefits:",
  simple:
    "We're committed to supporting your growth - with more than just our supplements.",
  buttonText: "More Details",
  buttonTextInline: "See the other benefits included in your subscription.",
  items: [
    {
      image: doctorIcon,
      text: "Wellness coaching with a naturopathic doctor",
      heading: "1:1 Naturopathic Doctor Wellness Consults",
      modalText:
        "Our licensed naturopathic doctors will take the time to learn about your hair health history—then create a personalized plan with essential wellness and lifestyle advice to ensure your success.",
    },
    {
      image: waveIcon,
      text: "Hair Mineral Analysis testing",
      heading: "Hair-Mineral Analysis",
      modalText:
        "An in-depth lab test with a small hair sample gives us insights into what root causes may be impacting your hair so we can precisely personalize your hair growth strategy.",
    },
    {
      image: headspaceIcon,
      text: "A Headspace subscription",
      heading: "Headspace Subscription",
      modalText:
        "Headspace offers access to a library of sleep, stress management, meditation tools, and more to help you reduce feelings of stress, form new habits and sleep more soundly--getting you closer to your wellness goals.",
    },
  ],
}
